/* global axios */
import ApiClient from './ApiClient';

class SocialInboxConfigsAPI extends ApiClient {
  constructor() {
    super('social_inbox_configs', { accountScoped: true });
  }

  // Contagens por inbox: { [inboxId]: { posts, comments, pending, platform } }
  stats() {
    return axios.get(`${this.url}/stats`);
  }
}

export default new SocialInboxConfigsAPI();
